/**
 * @generated SignedSource<<5e757bd3c221f811d09c17d1086919ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeedbacksTableV2_QueryFragment$data = {
  readonly Admin: {
    readonly FeedbackV2: {
      readonly Feedbacks: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly " $fragmentSpreads": FragmentRefs<"FeedbacksTableV2_FeedbackFragment">;
          };
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly endCursor: string | null | undefined;
          readonly hasNextPage: boolean;
          readonly hasPreviousPage: boolean;
          readonly startCursor: string | null | undefined;
        };
      };
    };
  };
  readonly " $fragmentType": "FeedbacksTableV2_QueryFragment";
};
export type FeedbacksTableV2_QueryFragment$key = {
  readonly " $data"?: FeedbacksTableV2_QueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"FeedbacksTableV2_QueryFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "Admin",
  "FeedbackV2",
  "Feedbacks"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": require('./FeedbacksTableV2_Refetch.graphql')
    }
  },
  "name": "FeedbacksTableV2_QueryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AdminQueryType",
      "kind": "LinkedField",
      "name": "Admin",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FeedbackV2AdminSchema",
          "kind": "LinkedField",
          "name": "FeedbackV2",
          "plural": false,
          "selections": [
            {
              "alias": "Feedbacks",
              "args": null,
              "concreteType": "FeedbacksConnection",
              "kind": "LinkedField",
              "name": "__FeedbacksTableV2_Feedbacks_connection",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endCursor",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasPreviousPage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasNextPage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startCursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FeedbacksEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FeedbackV2",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "id",
                          "storageKey": null
                        },
                        {
                          "kind": "InlineDataFragmentSpread",
                          "name": "FeedbacksTableV2_FeedbackFragment",
                          "selections": [
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "ActionColumn_FeedbackFragment"
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "ContentColumn_FeedbackFragment"
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "CreatedAtColumn_FeedbackFragment"
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "ScreenColumn_FeedbackFragment"
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "UserColumn_FeedbackFragment"
                            }
                          ],
                          "args": null,
                          "argumentDefinitions": []
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "__typename",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "a74dc45dbd7a32eb019bc08d5dcac947";

export default node;
